jQuery(document).ready(($) => {
	const requestButton = document.querySelector('.js-access-request-button')

	if (requestButton) {
		requestButton.addEventListener('click', handleAccessRequest)
	}
})

function handleAccessRequest(e) {
	const button = e.currentTarget
	const module = button.getAttribute('data-module')
	const notice = document.querySelector('.js-access-request-notice')

	jQuery.ajax({
		type: 'post',
		url: fp_js_object.admin_ajax_url,
		data: {
			action: 'access_request',
			module_id: module,
			_fp_nonce: fp_js_object.admin_ajax_nonce,
		},
		beforeSend() {
			button.classList.add('is-loading')
			button.textContent = access_request_strings.requesting
		},
		success() {
			button.remove()
			notice.setAttribute('data-status', 'success')
			notice.setAttribute('data-display', 'true')
			notice.textContent = access_request_strings.success
		},
		error() {
			button.textContent = access_request_strings.request
			button.classList.remove('is-loading')
			notice.setAttribute('data-status', 'error')
			notice.setAttribute('data-display', 'true')
			notice.textContent = access_request_strings.error
		},
	})
}
